import { useMemo, useState } from 'react';
import { getDefaultReportDates } from '@/utils/report';

type ReportDates = { from: Date; to: Date };

export const useReportDates = (_options?: {
  viewConfigId?: string;
}): [ReportDates, (dates: ReportDates) => void] => {
  const defaults = useMemo(() => getDefaultReportDates(), []);
  const [dates, setDates] = useState<ReportDates>({
    from: defaults.DEFAULT_FROM_DATE,
    to: defaults.DEFAULT_TO_DATE
  });
  return [dates, setDates];
};
